export const LoanStageConfigKeys = {
  PROPERTIES: "properties",
  BANK_ACCOUNT_TYPE_OPTIONS: "bank.account.type.options",
  PROFESSION_OPTIONS: "profession.options",
  EMI_STAGE_AVAILABLE_DATES: "emi.stage.available.dates",
  CREDIT_INFORMATION_REQUIRED: "credit.information.required",
  BANK_STATEMENT_INSTRUCTIONS: "bank.statement.instructions",
  HEADING: "heading",
  OPTIONS: "options"
};
